import authService from '../authService';
import configurationService from '../configurationService';
import mockAuthService from '../mocks/mockAuthService';

export default function () {
  if (
    configurationService.isLocalDev() &&
    !configurationService.isUsingLocalAuth()
  ) {
    return mockAuthService;
  }
  return authService;
}
